module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/1/2-40c975a5dc97090e3d0535cc67b15947.jpg";